import type { ResolveResult } from '../shared/types'
import { CopyRow } from './CopyRow'

/** 解析結果：純網址 + 完整網址 + 轉址鏈 + 處理說明。 */
export function Result({ result }: { result: ResolveResult }) {
  const hops = result.chain.length

  return (
    <div class="space-y-2.5">
      <CopyRow label="純網址" value={result.clean} emphasis />

      {result.clean !== result.final && <CopyRow label="完整網址（含參數）" value={result.final} />}

      {result.warning && (
        <p class="rounded-xl border border-amber-300/50 bg-amber-50 px-3.5 py-2.5 text-xs leading-relaxed text-amber-800 dark:border-amber-400/25 dark:bg-amber-400/10 dark:text-amber-200">
          {result.warning}
        </p>
      )}

      {result.notes.length > 0 && (
        <ul class="space-y-1 px-1 text-xs text-slate-500 dark:text-slate-400">
          {result.notes.map((note) => (
            <li key={note} class="flex gap-2">
              <span class="text-indigo-400 dark:text-cyan-400">·</span>
              <span>{note}</span>
            </li>
          ))}
        </ul>
      )}

      {hops > 1 && (
        <details class="card px-3.5 py-2.5">
          <summary class="cursor-pointer list-none text-xs font-medium text-slate-500 dark:text-slate-400">
            轉址鏈 {hops} 跳
            {result.cached && <span class="ml-2 text-slate-400 dark:text-slate-600">（快取）</span>}
          </summary>
          <ol class="mt-3 space-y-2">
            {result.chain.map((hop, i) => {
              const last = i === result.chain.length - 1
              return (
                <li key={hop.url} class="flex gap-2.5 text-xs">
                  <span class="mt-px w-9 shrink-0 text-right font-mono tabular-nums text-slate-400 dark:text-slate-600">
                    {hop.status || '—'}
                  </span>
                  <span
                    class={`url ${
                      last
                        ? 'text-slate-700 dark:text-slate-200'
                        : 'text-slate-400 dark:text-slate-500'
                    }`}
                  >
                    {hop.url}
                  </span>
                </li>
              )
            })}
          </ol>
        </details>
      )}
    </div>
  )
}
